// src/services/dataFetch.js

const BASE_URL = process.env.REACT_APP_API_URL

export const fetchRooms = async () => {
  const res = await fetch(`${BASE_URL}/rooms`);
  if (!res.ok) throw new Error('Failed to fetch rooms');
  return await res.json();
};

export const addRoom = async (room) => {
  const res = await fetch(`${BASE_URL}/rooms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(room),
  });
  if (!res.ok) throw new Error('Failed to add room');
  return await res.json();
};

export const updateRoom = async (id, room) => {
  const res = await fetch(`${BASE_URL}/rooms/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(room),
  });
  if (!res.ok) throw new Error('Failed to update room');
  return await res.json();
};

export const deleteRoom = async (id, force = false) => {
  const url = force ? `${BASE_URL}/rooms/${id}?force=true` : `${BASE_URL}/rooms/${id}`;
  const res = await fetch(url, {
    method: 'DELETE',
  });
  if (!res.ok) {
    // Try to extract error message from response
    const errorData = await res.json();
    // If it requires confirmation, throw a special error with the data
    if (errorData.requires_confirmation) {
      const error = new Error(errorData.error || 'Failed to delete room');
      error.requiresConfirmation = true;
      error.assignmentsCount = errorData.assignments_count;
      throw error;
    }
    throw new Error(errorData.error || 'Failed to delete room');
  }
  return await res.json();
};

export const fetchLevels = async () => {
  const res = await fetch(`${BASE_URL}/levels`);
  if (!res.ok) throw new Error('Failed to fetch levels');
  return await res.json();
};

export const addLevel = async (level) => {
  const res = await fetch(`${BASE_URL}/levels`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(level),
  });
  if (!res.ok) throw new Error('Failed to add level');
  return await res.json();
};

export const updateLevel = async (id, level) => {
  const res = await fetch(`${BASE_URL}/levels/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(level),
  });
  if (!res.ok) throw new Error('Failed to update level');
  return await res.json();
};

export const deleteLevel = async (id, force = false) => {
  const url = force ? `${BASE_URL}/levels/${id}?force=true` : `${BASE_URL}/levels/${id}`;
  const res = await fetch(url, {
    method: 'DELETE',
  });
  if (!res.ok) {
    // Try to extract error message from response
    const errorData = await res.json();
    // If it requires confirmation, throw a special error with the data
    if (errorData.requires_confirmation) {
      const error = new Error(errorData.error || 'Failed to delete level');
      error.requiresConfirmation = true;
      error.dependencies = errorData.dependencies;
      throw error;
    }
    throw new Error(errorData.error || 'Failed to delete level');
  }
  return await res.json();
};

// Modules
export const fetchModules = async () => {
  const res = await fetch(`${BASE_URL}/modules`);
  if (!res.ok) throw new Error('Failed to fetch modules');
  return await res.json();
};

export const addModule = async (module) => {
  const res = await fetch(`${BASE_URL}/modules`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(module),
  });
  if (!res.ok) throw new Error('Failed to add module');
  return await res.json();
};

export const updateModule = async (id, module) => {
  const res = await fetch(`${BASE_URL}/modules/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(module),
  });
  if (!res.ok) throw new Error('Failed to update module');
  return await res.json();
};

export const deleteModule = async (id, force = false) => {
  const url = force ? `${BASE_URL}/modules/${id}?force=true` : `${BASE_URL}/modules/${id}`;
  const res = await fetch(url, {
    method: 'DELETE',
  });
  if (!res.ok) {
    // Try to extract error message from response
    const errorData = await res.json();
    // If it requires confirmation, throw a special error with the data
    if (errorData.requires_confirmation) {
      const error = new Error(errorData.error || 'Failed to delete module');
      error.requiresConfirmation = true;
      error.dependencies = errorData.dependencies;
      throw error;
    }
    throw new Error(errorData.error || 'Failed to delete module');
  }
  return await res.json();
};


export const uploadFiles = async (olympFile, webshopFile) => {
  const formData = new FormData();
  formData.append('olymp', olympFile);
  formData.append('webshop', webshopFile);

  try {
    const response = await fetch(`${BASE_URL}/upload-and-process`, {
      method: 'POST',
      body: formData,
    });

    // First get the response as text
    const responseText = await response.text();
    
    try {
      // Try to parse as JSON
      const data = JSON.parse(responseText);
      
      if (!response.ok || !data.success) {
        throw new Error(data.error || 'Processing failed');
      }
      
      return data;
    } catch (e) {
      // If JSON parsing fails, throw with the raw response
      throw new Error(`Invalid server response: ${responseText.substring(0, 100)}...`);
    }
  } catch (error) {
    console.error('Error:', error);
    throw new Error(error.message || 'Failed to upload files');
  }
};